/**
 * SUPERCLIK PRO PRODUCT SECTION
 * Maneja ofertas por cantidad, modal COD, galería y WhatsApp
 */

class SuperclikProProduct {
  constructor() {
    this.productData = this.getProductData();
    this.selectedOffer = null;
    this.init();
  }

  init() {
    this.initGallery();
    this.initQuantityOffers();
    this.initCODModal();
    this.initProductForm();
    this.initWhatsApp();
  }

  // ==========================================
  // GALERÍA DE PRODUCTO
  // ==========================================
  initGallery() {
    const thumbnails = document.querySelectorAll('[data-thumbnail-button]');
    const mainImage = document.querySelector('[data-product-main-image]');
    
    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remover active de todos
        thumbnails.forEach(t => t.classList.remove('active'));
        
        // Agregar active al clickeado
        thumbnail.classList.add('active');
        
        // Obtener la imagen
        const img = thumbnail.querySelector('img');
        if (img) {
          const newSrc = img.src.replace('_200x', '_800x');
          
          // Animación suave
          mainImage.style.opacity = '0.5';
          setTimeout(() => {
            mainImage.src = newSrc;
            mainImage.style.opacity = '1';
          }, 150);
        }
      });
    });
  }

  // ==========================================
  // OFERTAS POR CANTIDAD
  // ==========================================
  initQuantityOffers() {
    const offerCards = document.querySelectorAll('[data-offer-card]');
    const quantityInput = document.querySelector('[data-quantity-input]');
    
    if (!offerCards.length || !quantityInput) return;

    offerCards.forEach(card => {
      card.addEventListener('click', () => {
        // Remover selección de todas las ofertas
        offerCards.forEach(c => c.classList.remove('scp-offer-card--selected'));
        
        // Seleccionar esta oferta
        card.classList.add('scp-offer-card--selected');
        
        // Obtener la cantidad de la oferta
        const offerQty = parseInt(card.getAttribute('data-offer-qty')) || 1;
        
        // Actualizar el input de cantidad
        quantityInput.value = offerQty;
        
        // Guardar la oferta seleccionada
        this.selectedOffer = {
          quantity: offerQty,
          title: card.querySelector('.scp-offer-name')?.textContent || '',
          price: card.querySelector('.scp-offer-price-now')?.textContent || ''
        };

        // Animación de selección
        card.style.transform = 'scale(0.98)';
        setTimeout(() => {
          card.style.transform = 'scale(1)';
        }, 150);
      });
    });

    // Seleccionar la primera oferta por defecto si está marcada como featured
    const featuredOffer = document.querySelector('.scp-offer-card--featured');
    if (featuredOffer) {
      featuredOffer.click();
    }
  }

  // ==========================================
  // MODAL PAGAR EN CASA (COD)
  // ==========================================
  initCODModal() {
    const modal = document.querySelector('[data-cod-modal]');
    const openButtons = document.querySelectorAll('[data-cod-open]');
    const closeButtons = document.querySelectorAll('[data-cod-close]');
    const form = document.querySelector('[data-cod-form]');
    
    if (!modal) return;

    // Abrir modal
    openButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.openCODModal(modal);
      });
    });

    // Cerrar modal
    closeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        this.closeCODModal(modal);
      });
    });

    // Cerrar al hacer click en overlay
    const overlay = modal.querySelector('.cod-modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        this.closeCODModal(modal);
      });
    }

    // Manejar envío del formulario
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submitCODForm(form, modal);
      });
    }

    // Actualizar totales cuando cambia la cantidad
    const quantityInput = document.querySelector('[data-quantity-input]');
    if (quantityInput) {
      quantityInput.addEventListener('change', () => {
        this.updateCODTotals();
      });
    }
  }

  openCODModal(modal) {
    modal.classList.add('cod-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Actualizar información en el modal
    this.updateCODTotals();
  }

  closeCODModal(modal) {
    modal.classList.remove('cod-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  updateCODTotals() {
    if (!this.productData) return;

    const quantityInput = document.querySelector('[data-quantity-input]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    const unitPrice = this.productData.selected_or_first_available_variant.price;
    const total = unitPrice * quantity;

    // Actualizar subtotal
    const subtotalElements = document.querySelectorAll('[data-cod-subtotal]');
    subtotalElements.forEach(el => {
      el.textContent = this.formatMoney(total);
    });

    // Actualizar total
    const totalElements = document.querySelectorAll('[data-cod-total], [data-cod-total-2]');
    totalElements.forEach(el => {
      el.textContent = this.formatMoney(total);
    });
  }

  submitCODForm(form, modal) {
    // Validar formulario
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const formData = new FormData(form);
    
    // Obtener datos del producto
    const quantityInput = document.querySelector('[data-quantity-input]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    // Construir mensaje para WhatsApp
    let message = '🛒 *PEDIDO - PAGAR EN CASA*\n\n';
    message += '━━━━━━━━━━━━━━━━━━━━\n';
    message += '*PRODUCTO*\n';
    message += `📦 ${this.productData.title}\n`;
    
    const variant = this.productData.selected_or_first_available_variant;
    if (variant.title && variant.title !== 'Default Title') {
      message += `📋 Variante: ${variant.title}\n`;
    }
    
    message += `🔢 Cantidad: ${quantity}\n`;
    message += `💰 Precio unidad: ${this.formatMoney(variant.price)}\n`;
    message += `💵 *TOTAL: ${this.formatMoney(variant.price * quantity)}*\n\n`;
    
    message += '━━━━━━━━━━━━━━━━━━━━\n';
    message += '*DATOS DE ENTREGA*\n';
    message += `👤 Nombre: ${formData.get('attributes[Nombre]')}\n`;
    message += `📱 Teléfono: ${formData.get('attributes[Telefono]')}\n`;
    message += `📍 Dirección: ${formData.get('attributes[Direccion]')}\n`;
    message += `🏙️ Comuna: ${formData.get('attributes[Comuna]')}\n`;
    message += `🗺️ Región: ${formData.get('attributes[Region]')}\n`;
    
    const notes = formData.get('attributes[Notas]');
    if (notes) {
      message += `\n📝 *Notas:*\n${notes}\n`;
    }
    
    const bump = formData.get('attributes[Bump]');
    if (bump) {
      message += `\n✅ Extra: ${bump}\n`;
    }
    
    message += '\n━━━━━━━━━━━━━━━━━━━━\n';
    message += '💳 *Método de pago: PAGAR EN CASA*';

    // Obtener número de WhatsApp
    const whatsappNumber = window.whatsappNumber || document.body.dataset.whatsappNumber;
    
    if (!whatsappNumber) {
      alert('Error: Número de WhatsApp no configurado');
      return;
    }

    // Abrir WhatsApp
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, '_blank');

    // Cerrar modal y limpiar formulario
    this.closeCODModal(modal);
    form.reset();

    // Mostrar mensaje de éxito
    this.showSuccessMessage('¡Pedido enviado! Te contactaremos por WhatsApp para confirmar.');
  }

  // ==========================================
  // FORMULARIO DE PRODUCTO
  // ==========================================
  initProductForm() {
    const form = document.getElementById('product-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      await this.addToCart(form);
    });

    // Botones de cantidad
    const minusBtn = document.querySelector('[data-quantity-minus]');
    const plusBtn = document.querySelector('[data-quantity-plus]');
    const quantityInput = document.querySelector('[data-quantity-input]');

    if (minusBtn && quantityInput) {
      minusBtn.addEventListener('click', () => {
        const value = parseInt(quantityInput.value) || 1;
        if (value > 1) {
          quantityInput.value = value - 1;
          this.updateCODTotals();
        }
      });
    }

    if (plusBtn && quantityInput) {
      plusBtn.addEventListener('click', () => {
        const value = parseInt(quantityInput.value) || 1;
        quantityInput.value = value + 1;
        this.updateCODTotals();
      });
    }

    // Prevenir valores negativos o cero
    if (quantityInput) {
      quantityInput.addEventListener('change', () => {
        const value = parseInt(quantityInput.value) || 1;
        if (value < 1) {
          quantityInput.value = 1;
        }
        this.updateCODTotals();
      });
    }

    // Opciones de producto (variantes)
    const optionInputs = document.querySelectorAll('[data-option-input]');
    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.updateVariant();
      });
    });
  }

  async addToCart(form) {
    try {
      const submitBtn = form.querySelector('[data-add-to-cart]');
      const btnText = submitBtn.querySelector('[data-add-to-cart-text]');
      const originalText = btnText.textContent;

      // Deshabilitar botón
      submitBtn.disabled = true;
      btnText.textContent = 'Agregando...';

      // Enviar al carrito
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Error al agregar al carrito');
      }

      const item = await response.json();

      // Animación de éxito
      submitBtn.classList.add('shake');
      setTimeout(() => submitBtn.classList.remove('shake'), 500);

      // Actualizar contador del carrito si existe CartManager
      if (window.cartManager) {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        window.cartManager.updateCartCount(cart.item_count);
        window.cartManager.openDrawer();
        await window.cartManager.refreshCart();
      }

      // Restaurar botón
      submitBtn.disabled = false;
      btnText.textContent = originalText;

      // Mensaje de éxito
      this.showSuccessMessage('¡Producto agregado al carrito!');

    } catch (error) {
      console.error('Error:', error);
      alert('Error al agregar al carrito. Por favor intenta de nuevo.');
      
      const submitBtn = form.querySelector('[data-add-to-cart]');
      submitBtn.disabled = false;
    }
  }

  updateVariant() {
    // Obtener todas las opciones seleccionadas
    const options = [];
    document.querySelectorAll('[data-option-input]:checked').forEach(input => {
      options.push(input.value);
    });

    // Buscar la variante que coincida
    if (!this.productData) return;

    const variant = this.productData.variants.find(v => {
      return options.every((option, index) => {
        return v.options[index] === option;
      });
    });

    if (variant) {
      // Actualizar el input hidden con el ID de la variante
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variant.id;
      }

      // Actualizar precio
      this.updatePrice(variant);

      // Actualizar disponibilidad del botón
      const addBtn = document.querySelector('[data-add-to-cart]');
      const btnText = addBtn?.querySelector('[data-add-to-cart-text]');
      
      if (addBtn && btnText) {
        if (variant.available) {
          addBtn.disabled = false;
          btnText.textContent = addBtn.dataset.addLabel || 'Agregar al carrito';
        } else {
          addBtn.disabled = true;
          btnText.textContent = 'Agotado';
        }
      }
    }
  }

  updatePrice(variant) {
    const priceElement = document.querySelector('.scp-price-sale');
    const compareElement = document.querySelector('.scp-price-compare');

    if (priceElement) {
      priceElement.textContent = this.formatMoney(variant.price);
    }

    if (compareElement && variant.compare_at_price > variant.price) {
      compareElement.innerHTML = `<s>${this.formatMoney(variant.compare_at_price)}</s>`;
      compareElement.style.display = 'inline';
    } else if (compareElement) {
      compareElement.style.display = 'none';
    }

    // Actualizar totales en el modal COD
    this.updateCODTotals();
  }

  // ==========================================
  // WHATSAPP
  // ==========================================
  initWhatsApp() {
    const whatsappBtn = document.querySelector('[data-product-whatsapp]');
    if (!whatsappBtn) return;

    whatsappBtn.addEventListener('click', () => {
      this.sendToWhatsApp();
    });
  }

  sendToWhatsApp() {
    if (!this.productData) return;

    const variant = this.productData.selected_or_first_available_variant;
    const quantityInput = document.querySelector('[data-quantity-input]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    let message = '¡Hola! Me interesa este producto:\n\n';
    message += `📦 *${this.productData.title}*\n`;
    
    if (variant.title && variant.title !== 'Default Title') {
      message += `📋 Variante: ${variant.title}\n`;
    }
    
    message += `🔢 Cantidad: ${quantity}\n`;
    message += `💰 Precio: ${this.formatMoney(variant.price * quantity)}\n\n`;
    message += `🔗 Link: ${window.location.href}\n\n`;
    message += `¿Podrían darme más información?`;

    const whatsappNumber = window.whatsappNumber || document.body.dataset.whatsappNumber;
    
    if (!whatsappNumber) {
      alert('Error: Número de WhatsApp no configurado');
      return;
    }

    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, '_blank');
  }

  // ==========================================
  // UTILIDADES
  // ==========================================
  getProductData() {
    const dataElement = document.querySelector('[data-product-json]');
    if (!dataElement) return null;

    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Error parsing product data:', error);
      return null;
    }
  }

  formatMoney(cents) {
    const amount = cents / 100;
    return '$' + amount.toLocaleString('es-CL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  showSuccessMessage(message) {
    // Crear elemento de notificación
    const notification = document.createElement('div');
    notification.className = 'scp-notification';
    notification.textContent = message;
    
    document.body.appendChild(notification);

    // Mostrar
    setTimeout(() => {
      notification.classList.add('scp-notification--show');
    }, 100);

    // Ocultar y eliminar después de 3 segundos
    setTimeout(() => {
      notification.classList.remove('scp-notification--show');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }
}

// ==========================================
// CART MANAGER - Manejo global del carrito
// ==========================================
class CartManager {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.overlay = document.querySelector('[data-cart-drawer-overlay]');
    this.closeButtons = document.querySelectorAll('[data-cart-drawer-close]');
    this.cartButtons = document.querySelectorAll('.scp-cart-btn');

    this.init();
  }

  init() {
    // Abrir carrito
    this.cartButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.openDrawer();
      });
    });

    // Cerrar carrito
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.closeDrawer());
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeDrawer());
    }

    // Manejar cantidad
    this.setupQuantityHandlers();

    // ESC para cerrar
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer && this.drawer.classList.contains('is-open')) {
        this.closeDrawer();
      }
    });
  }

  openDrawer() {
    if (this.drawer) {
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.refreshCart();
    }
  }

  closeDrawer() {
    if (this.drawer) {
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  async refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      this.updateCartCount(cart.item_count);
      await this.updateCartHTML();
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }

  updateCartCount(count) {
    const countElements = document.querySelectorAll('[data-cart-count]');
    countElements.forEach(el => {
      el.textContent = count;
    });

    const badges = document.querySelectorAll('.scp-cart-count');
    badges.forEach(badge => {
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  async updateCartHTML() {
    try {
      const response = await fetch('/?sections=cart-drawer');
      const data = await response.json();

      // Actualizar el contenido del drawer si existe
      const bodyContent = document.querySelector('[data-cart-drawer-body]');
      if (bodyContent && data['cart-drawer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newBody = doc.querySelector('[data-cart-drawer-body]');

        if (newBody) {
          bodyContent.innerHTML = newBody.innerHTML;
          this.setupQuantityHandlers();
        }
      }
    } catch (error) {
      console.error('Error updating cart HTML:', error);
    }
  }

  setupQuantityHandlers() {
    // Incrementar cantidad
    document.querySelectorAll('[data-increase-quantity]').forEach(btn => {
      btn.addEventListener('click', () => {
        const line = btn.dataset.line;
        this.updateQuantity(line, 1);
      });
    });

    // Decrementar cantidad
    document.querySelectorAll('[data-decrease-quantity]').forEach(btn => {
      btn.addEventListener('click', () => {
        const line = btn.dataset.line;
        this.updateQuantity(line, -1);
      });
    });

    // Eliminar item
    document.querySelectorAll('[data-remove-item]').forEach(btn => {
      btn.addEventListener('click', () => {
        const line = btn.dataset.line;
        this.removeItem(line);
      });
    });
  }

  async updateQuantity(line, change) {
    const quantityDisplay = document.querySelector(`[data-line="${line}"] [data-quantity]`);
    if (!quantityDisplay) return;

    const currentQty = parseInt(quantityDisplay.textContent);
    const newQty = currentQty + change;

    if (newQty < 1) {
      this.removeItem(line);
      return;
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: newQty
        })
      });

      if (response.ok) {
        await this.refreshCart();
      }
    } catch (error) {
      console.error('Error updating quantity:', error);
    }
  }

  async removeItem(line) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: 0
        })
      });

      if (response.ok) {
        await this.refreshCart();
      }
    } catch (error) {
      console.error('Error removing item:', error);
    }
  }
}

// ==========================================
// SCROLL ANIMATIONS - Intersection Observer
// ==========================================
class ScrollAnimations {
  constructor() {
    this.observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    this.init();
  }

  init() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, this.observerOptions);

    // Observar todos los elementos con clases de animación
    const animatedElements = document.querySelectorAll(`
      .animate-fade-in-up,
      .animate-fade-in-down,
      .animate-fade-in-left,
      .animate-fade-in-right,
      .animate-zoom-in,
      .animate-bounce-in,
      .footer-block,
      .hero-text > *,
      .hero-image
    `);

    animatedElements.forEach(el => {
      el.style.opacity = '0';
      observer.observe(el);
    });
  }
}

// Añadir clase cuando el elemento es visible
const style = document.createElement('style');
style.textContent = `
  .is-visible {
    animation-play-state: running !important;
    opacity: 1 !important;
  }
`;
document.head.appendChild(style);

// ==========================================
// SMOOTH SCROLL - Navegación suave
// ==========================================
class SmoothScroll {
  constructor() {
    this.init();
  }

  init() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        const href = anchor.getAttribute('href');

        if (href === '#' || !href) return;

        const target = document.querySelector(href);

        if (target) {
          e.preventDefault();

          const headerOffset = 80;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          // Cerrar menú móvil si está abierto
          const drawer = document.getElementById('scp-menu-drawer');
          if (drawer && drawer.classList.contains('is-open')) {
            drawer.classList.remove('is-open');
            document.body.style.overflow = '';
          }
        }
      });
    });
  }
}

// ==========================================
// LAZY LOADING MEJORADO - Imágenes
// ==========================================
class LazyLoader {
  constructor() {
    this.init();
  }

  init() {
    if ('loading' in HTMLImageElement.prototype) {
      // Navegador soporta lazy loading nativo
      const images = document.querySelectorAll('img[loading="lazy"]');
      images.forEach(img => {
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
      });
    } else {
      // Fallback con Intersection Observer
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.classList.add('loaded');
              observer.unobserve(img);
            }
          }
        });
      });

      document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    }
  }
}

// ==========================================
// PARALLAX SIMPLE - Efectos de profundidad
// ==========================================
class ParallaxEffect {
  constructor() {
    this.elements = document.querySelectorAll('[data-parallax]');
    if (this.elements.length > 0) {
      this.init();
    }
  }

  init() {
    window.addEventListener('scroll', () => {
      requestAnimationFrame(() => {
        this.elements.forEach(el => {
          const speed = el.dataset.parallax || 0.5;
          const yPos = -(window.pageYOffset * speed);
          el.style.transform = `translateY(${yPos}px)`;
        });
      });
    }, { passive: true });
  }
}

// ==========================================
// INICIALIZACIÓN GLOBAL
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  // Inicializar Cart Manager
  window.cartManager = new CartManager();
  console.log('Cart Manager initialized');

  // Inicializar animaciones de scroll
  new ScrollAnimations();
  console.log('Scroll Animations initialized');

  // Inicializar smooth scroll
  new SmoothScroll();
  console.log('Smooth Scroll initialized');

  // Inicializar lazy loading
  new LazyLoader();
  console.log('Lazy Loader initialized');

  // Inicializar parallax
  new ParallaxEffect();
  console.log('Parallax Effect initialized');

  // Inicializar producto PRO si existe
  if (document.querySelector('[data-section-type="product"]')) {
    window.superclikProProduct = new SuperclikProProduct();
    console.log('Superclik PRO Product initialized');
  }

  // Inicializar Quick Add buttons
  initQuickAdd();

  // Logging para debug
  console.log('%c🚀 Superclik Theme Loaded Successfully!', 'color: #3b82f6; font-size: 16px; font-weight: bold;');
});

// ==========================================
// QUICK ADD - Agregar al carrito desde cards
// ==========================================
function initQuickAdd() {
  const quickAddButtons = document.querySelectorAll('[data-quick-add]');

  quickAddButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = button.dataset.quickAdd;
      const originalText = button.textContent;

      // Deshabilitar botón
      button.disabled = true;
      button.textContent = 'Agregando...';

      try {
        // Agregar al carrito
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });

        if (!response.ok) {
          throw new Error('Error al agregar al carrito');
        }

        const item = await response.json();

        // Animación de éxito
        button.classList.add('button-success');
        button.textContent = '✓ Agregado';

        // Actualizar carrito si existe CartManager
        if (window.cartManager) {
          await window.cartManager.refreshCart();
          window.cartManager.openDrawer();
        }

        // Restaurar botón después de 2 segundos
        setTimeout(() => {
          button.classList.remove('button-success');
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);

      } catch (error) {
        console.error('Error:', error);

        // Mostrar error
        button.classList.add('button-error');
        button.textContent = '✗ Error';

        setTimeout(() => {
          button.classList.remove('button-error');
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    });
  });
}